import script from "./CheckinAlertsTableLoader.vue?vue&type=script&setup=true&lang=js"
export * from "./CheckinAlertsTableLoader.vue?vue&type=script&setup=true&lang=js"

import "./CheckinAlertsTableLoader.vue?vue&type=style&index=0&id=d8ab3b62&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d8ab3b62"]])

export default __exports__